import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { ToastProvider } from '@kainos/ui';
import { AuthProvider } from '@/lib/auth';
import { UiProvider } from '@/store/ui-store';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import { createQueryClient } from './query-client';

/**
 * Application-wide providers, outermost first.
 *
 * The query client is created in state so React 19 strict-mode double renders
 * do not throw away the cache on mount.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UiProvider>
            <ToastProvider>{children}</ToastProvider>
          </UiProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
